export default __webpack_public_path__ + "static/media/arrow.c76d1628.svg";